import request from '@/util/request';


//获取租户下拉框

export const tenantGetList = (params, options) =>
request.get(
  '/api/charger-system/tenant/getList',
  Object.assign({}, options, { params })
);
 //获取代理商下拉框

 export const agentGetList = (params, options) =>
 request.get(
   '/api/v4ward/saas/charger/agent/getList',
   Object.assign({}, options, { params })
 );

  //获取物业下拉框

  export const propertyGetList = (params, options) =>
  request.get(
    '/api/v4ward/saas/charger/property/getList',
    Object.assign({}, options, { params })
  );

   //获取小区下拉框

   export const areaGetList = (params, options) =>
   request.get(
     '/api/v4ward/saas/charger/area/getList',
     Object.assign({}, options, { params })
   );



//充电站下拉框

export const stationGetList = (params, options) =>
request.get(
 '/api/v4ward/saas/charger/station/getList',
 Object.assign({}, options, { params })
);


//升级

export const upgradeRecordPage = (params, options) =>
request.get(
 '/api/v4ward/park/upgradeRecord/page',
 Object.assign({}, options, { params })
);

//升级移除
export const upgradeRecordRemove= (params, options) =>
request.post('/api/v4ward/park/upgradeRecord/remove',params,options);

//重启分页

export const getRestartDevicePage = (params, options) =>
request.get(
 '/api/v4ward/charger/restartRecord/getRestartDevicePage',
 Object.assign({}, options, { params })
);

//带重启分页

export const getRestartStationPage = (params, options) =>
request.get(
 '/api/v4ward/charger/restartRecord/getRestartAreaPage',
 Object.assign({}, options, { params })
);

//充电站分页

export const stationPage = (params, options) =>
request.get(
 '/api/v4ward/saas/charger/area/nonEmphasisAreaPage',
 Object.assign({}, options, { params })
);
//批量添加关联
export const updateEmphasisStation= (params, options) =>
request.post('/api/v4ward/saas/charger/area/updateEmphasisArea',params,options);

//重点关注移除
export const removeEmphasisStation= (params, options) =>
request.post('/api/v4ward/saas/charger/area/removeEmphasisArea',params,options);